import { useEffect, useState } from 'react';
export default function useScreenWidthInfo() {
    var layoutWidthSM = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--layout-width-sm'));
    var layoutWidthMD = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--layout-width-md'));
    var layoutWidthLG = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--layout-width-lg'));
    var layoutWidthXL = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--layout-width-xl'));
    var getScreenWidthInfo = function () {
        var innerWidth = window.innerWidth;
        return {
            isSmallerThanLayoutWidthSM: !!layoutWidthSM && innerWidth < layoutWidthSM,
            isSmallerThanLayoutWidthMD: !!layoutWidthMD && innerWidth < layoutWidthMD,
            isSmallerThanLayoutWidthLG: !!layoutWidthLG && innerWidth < layoutWidthLG,
            isSmallerThanLayoutWidthXL: !!layoutWidthXL && innerWidth < layoutWidthXL,
        };
    };
    var _a = useState(getScreenWidthInfo()), screenWidthInfo = _a[0], setScreenWidthInfo = _a[1];
    var handleResize = function () {
        setScreenWidthInfo(getScreenWidthInfo());
    };
    useEffect(function () {
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    });
    return screenWidthInfo;
}
